import React, { ReactNode } from 'react';
import { RestrictedAccess } from '../RestrictedAccess/RestrictedAccess';

import './Widget.scss';

export interface WidgetProps {
  className?: string;
  children: ReactNode;
  permissions?: string[];
  title?: string;
  titleElement?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

export const Widget: React.FC<WidgetProps> = ( props ) => {
  const { children, className, title, permissions, titleElement = 'h2' } = props;
  const TitleElement = titleElement;

  return (
    <section data-testid="ops-widget" className={ `ops-widget${className ? ` ${className}` : ''}` }>
      <RestrictedAccess permissions={ permissions || [] }>
        <div className="ops-widget__inner">
          <TitleElement className="ops-widget__title">{ title }</TitleElement>
          <article className="ops-widget__content">{ children }</article>
        </div>
      </RestrictedAccess>
    </section>
  );
};

Widget.displayName = 'Widget';